import { Tendermint34Client } from "@cosmjs/tendermint-rpc";
import {
    QueryClient,
    setupDistributionExtension,
    setupStakingExtension,
    StargateClient
} from "@cosmjs/stargate";
import {divisionDecimals} from "./util";

async function makeClientWithDistribution(rpcUrl) {
    const tmClient = await Tendermint34Client.connect(rpcUrl);
    return [QueryClient.withExtensions(tmClient, setupDistributionExtension), tmClient];
}

async function makeClientWithStaking(rpcUrl) {
    const tmClient = await Tendermint34Client.connect(rpcUrl);
    return [QueryClient.withExtensions(tmClient, setupStakingExtension), tmClient];
}

export async function getUserStakedReward(address, validatorAddress, rpc = 'https://rpc.testnet.kava.io/') {
    try {
        const [client, tmClient] = await makeClientWithDistribution(rpc);
        const response = await client.distribution.delegationRewards(
            address,
            validatorAddress
        );
        // const test = await client.distribution.delegationTotalRewards(
        //     address
        // );
        // console.log(test, '123test')
        // console.log(response, 'rewards')
        return response.rewards[0] || {};
    } catch (e) {
        console.log(e, 'error');
        return {};
    }
}

export async function getUserUnbondingDelegation(rpc, address, validatorAddress) {
    try {
        const [client, tmClient] = await makeClientWithStaking(rpc);
        const response = await client.staking.unbondingDelegation(
            address,
            validatorAddress
        );
        const params = await client.staking.params();
        console.log(params.params.unbondingTime.seconds.low, 'params11');
        console.log(response, 'response');
        if (response && response.unbond) {
            let total = 0;
            response.unbond.entries.forEach(item => {
                total += Number(item.balance || 0);
            });
            return {
                reward: divisionDecimals(total, 6),
                currentEntries: response.unbond.entries.length
            };
        }
        return {
            reward: 0,
            currentEntries: response && response.unbond && response.unbond.entries && response.unbond.entries.length || 0
        };
    } catch (e) {
        return {
            reward: 0,
            currentEntries: 0
        };
    }
}

export async function getValidatorUnlockTime(rpc) {
    try {
        const [client] = await makeClientWithStaking(rpc);
        const params = await client.staking.params();
        console.log(params, params.params.unbondingTime.seconds.low, 'params');
        return {
            unlockTime: params && params.params && params.params.unbondingTime.seconds.low / 3600 / 24 || 0,
            maxEntries: params && params.params && params.params.maxEntries
        };
    } catch (e) {
        console.error(e, 'e');
        return {
            unlockTime: 0,
            maxEntries: 7
        };
    }
}

export async function getCosmosClient(rpc) {
    try {
        return await StargateClient.connect(rpc);
    } catch (e) {
        console.error(e, 'error');
    }
}

export async function getCosmosAssetBalance(userAddress, demon, client) {
    try {
        // const client = await getCosmosClient(rpc);
        // const test = await client.getAllBalances(userAddress);
        // console.log(test, '123')
        return await client.getBalance(userAddress, demon);
    } catch (e) {
        console.error(e);
        return {};
    }
}

export async function getCosmosDelegation(userAddress, validatorAddress, client) {
    try {
        return await client.getDelegation(userAddress, validatorAddress);
    } catch (e) {
        console.error(e);
        return {};
    }
}
